import { v4 as uuidv4 } from "uuid";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly extra?: Record<string, unknown>,
  ) {
    super(message);
  }
}

export async function apiFetch<T>(
  path: string,
  init: RequestInit = {},
  withIdempotencyKey = false,
): Promise<T> {
  const headers = new Headers(init.headers);
  let body: BodyInit | null = init.body ?? null;
  if (withIdempotencyKey && init.body) {
    const parsed = JSON.parse(init.body as string);
    body = JSON.stringify({ ...parsed, idempotencyKey: uuidv4() });
    headers.set("content-type", "application/json");
  } else if (init.body) {
    headers.set("content-type", "application/json");
  }
  const res = await fetch(path, { ...init, headers, body });
  if (res.status === 401) {
    window.location.href = "/login";
    throw new ApiError(401, "unauthenticated", "Redirecting to login");
  }
  const text = await res.text();
  const json = text ? (JSON.parse(text) as Record<string, unknown>) : {};
  if (!res.ok) {
    throw new ApiError(
      res.status,
      (json["error"] as string | undefined) ?? "error",
      (json["message"] as string | undefined) ?? `HTTP ${res.status}`,
      json,
    );
  }
  return json as T;
}
